<div class="right-side">
  <form [formGroup]="form1" #form="ngForm">
    <div class="p-5">
      <div class="card-title">
        <h2>Change Password</h2>
      </div>
      <div class="section">
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="nowrap" for="username">User Name</label>
            <input type="text" autocomplete="off" formControlName="username" class="form-control"
                   id="txtusername" placeholder="User Name" [value]="readonlyUsername" readonly="readonly"><!--{{readonlyUsername}}-->
            <div *ngIf="f['username'].touched && f['username'].invalid" class="alert alert-danger required">
              <div *ngIf="f['username'].errors && f['username'].errors['required']">
                Invalid User Name
              </div>
              <div *ngIf="f['username'].errors && f['username'].errors['minlength']">
                Invalid User Name
              </div>
            </div>

          </div>
          <div class="col-md-6">
            <label class="nowrap">Old Password</label>
            <input type="password" autocomplete="off" formControlName="oldpassword" class="form-control"
                   id="txtoldpassword" placeholder="Old Password">
            <div *ngIf="f['oldpassword'].touched && f['oldpassword'].invalid">
              <!-- Required Error -->
              <div *ngIf="f['oldpassword'].errors && f['oldpassword'].errors?.['required']" class="alert alert-danger required">
                Old Password is required.
              </div>
            </div>
            

          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="nowrap">New Password</label>
            <!--<div class="input-group">
              <input [type]="showNewPassword ? 'text' : 'password'" autocomplete="off" formControlName="newpassword"
                     class="form-control" id="txtnewpassword" placeholder="New Password" maxlength="20">
              <div class="input-group-append">
                <span class="input-group-text picon" (click)="toggleShowNewPassword()" style="cursor: pointer;">
                  <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </span>
              </div>
            </div>
            <div *ngIf="f['newpassword'].touched && f['newpassword'].invalid">-->
            <!-- Required Error -->
            <!--<div *ngIf="f['newpassword'].errors && f['newpassword'].errors['required']" class="alert alert-danger required">
              New password is required.
            </div>-->
            <!-- Min Length Error -->
            <!--<div *ngIf="f['newpassword'].errors && f['newpassword'].errors['minlength']" class="alert alert-danger required">
              Minimum length should be 3 characters.
            </div>-->
            <!-- Max Length Error -->
            <!--<div *ngIf="f['newpassword'].errors && f['newpassword'].errors['maxlength']" class="alert alert-danger required">
              Maximum length should be 20 characters.
            </div>-->
            <!-- Pattern Error -->
            <!--<div *ngIf="f['newpassword'].errors && f['newpassword'].errors['pattern']" class="alert alert-danger required">
                New password must contain at least one lowercase letter, one uppercase letter, one numeric character, and one special character.
              </div>
            </div>-->

            <div class="input-group">
              <input [type]="showNewPassword ? 'text' : 'password'" autocomplete="off" formControlName="newpassword"
                     class="form-control" id="txtnewpassword" placeholder="New Password" maxlength="20">
              <div class="input-group-append">
                <span class="input-group-text picon" (click)="toggleShowNewPassword()" style="cursor: pointer;">
                  <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </span>
              </div>
            </div>
            <div *ngIf="f['newpassword'].touched && f['newpassword'].invalid">
              <!-- Required Error -->
              <div *ngIf="f['newpassword'].errors && f['newpassword'].errors['required']" class="alert alert-danger required">
                New Password is required. It must contain at least one lowercase letter, one uppercase letter, one numeric character, and one special character.
              </div>

              <!-- Min Length Error -->
              <div *ngIf="f['newpassword'].errors && f['newpassword'].errors['minlength']" class="alert alert-danger required">
                Minimum length should be 8 characters.
              </div>

              <!-- Max Length Error -->
              <div *ngIf="f['newpassword'].errors && f['newpassword'].errors['maxlength']" class="alert alert-danger required">
                Maximum length should be 20 characters.
              </div>

              <!-- Pattern Error -->
              <div *ngIf="f['newpassword'].errors && f['newpassword'].errors['pattern']" class="alert alert-danger required">
                Password must contain at least one lowercase letter, one uppercase letter, one numeric character, and one special character.
              </div>
            </div>

          </div>
          <div class="col-md-6">
            <label class="nowrap">Confirm New Password</label>
            <div class="input-group">
              <input [type]="showConfirmNewPassword ? 'text' : 'password'" autocomplete="off" formControlName="confirmnewpassword"
                     class="form-control" id="txtConfirmNewPassword" placeholder="Confirm New Password" maxlength="20"
                     (paste)="onPaste($event)">
              <div class="input-group-append">
                <span class="input-group-text picon" (click)="toggleShowConfirmNewPassword()" style="cursor: pointer;">
                  <i class="fa" [ngClass]="showConfirmNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </span>
              </div>
            </div>
            <div *ngIf="f['confirmnewpassword'].touched && f['confirmnewpassword'].invalid">
              <!--Required Error-->
              <div *ngIf="f['confirmnewpassword'].errors && f['confirmnewpassword'].errors['required']" class="alert alert-danger required">
                Confirm password is required.
              </div>
              <!--Min Length Error-->
              <div *ngIf="f['confirmnewpassword'].errors?.['minlength']" class="alert alert-danger required">
                Minimum length should be 8 characters.
              </div>
              <!--Max Length Error-->
              <div *ngIf="f['confirmnewpassword'].errors?.['maxlength']" class="alert alert-danger required">
                Maximum length should be 20 characters.
              </div>
              <!--Password Mismatch Error-->
              <div *ngIf="f['confirmnewpassword'].errors?.['passwordMismatch']" class="alert alert-danger required">
                Password and Confirm Password fields must match.
              </div>
            </div>

          </div>
        </div>
        <!--</div>-->



        <div  class="mt-3 text-center">
          <button class="btn btn-success me-2" id=" btnChangePassword" type="submit" (click)="onSubmit()"><i class="bi bi-person-check"></i> Update</button>

          <button id="btncancel" type="button" (click)="onReset()" class="btn btn-danger me-2">
            <i class="bi bi-arrow-clockwise"></i> Reset
          </button>

          <button class="btn btn-danger" id="btnBack" type="button" (click)="onCancel()"><i class="bi bi-x-circle"></i> Cancel</button>

         
        </div>
      </div>
    </div>
  </form>
</div>



